import type { IControlError } from '../../../../core/Controls';
import type { IDispatcher } from '../../../helpers/Dispatcher';
import type { CreatorErrorSetter } from '../types';

interface Props {
  error: IControlError;
  visited: boolean;
  schema: any;
  value: any;
  dispatcher: IDispatcher;
}

export const errorHandlers = (props: Props) => {
  const { error, visited, value, schema, dispatcher } = props;

  const getError = () => {
    // @ts-ignore
    const errorText = visited && error?.message;
    let className = 'default';
    if (value && !errorText) {
      className = 'success';
    } else if (errorText) {
      className = 'error';
    }
    return {
      className,
      errorText,
    };
  };

  const setError: CreatorErrorSetter = (title, message) => {
    dispatcher.setError(
      schema.id,
      undefined,
      {
        message: title,
      },
      true,
    );

    /**
     * TODO: тип пропсов dispatcher.notify неверный, нужно поправить
     * принимает message: string,
     * но по факту message: React.ReactNode
     */
    //@ts-ignore
    dispatcher.notify(message);
  };

  return { getError, setError };
};
